define('presentation/common/actionModal/viewModels/deleteWebChatWidgetActionViewModel',[
    'businessServices/authentication/sessionAccountInfo',
    'common/promises/promiseFactory',
    'common/storage/commonState',
    'settings/navigationConfiguration'
], function() {
    return function(widget) {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _commonState = require('common/storage/commonState');
        const _navigationConfiguration = require('settings/navigationConfiguration');
        const _sessionAccountInfo = require('businessServices/authentication/sessionAccountInfo');

        self.widget = {};
        self.type = _commonState.typeDisplay.webChatWidget.toLowerCase();
        self.plansUrl = _navigationConfiguration.routesById.plans.url;
        self.isBillingAdmin = _sessionAccountInfo.isBillingAdmin();

        self.activate = () => {
            self.widget = widget;

            return _promiseFactory.wait();
        };
    };
});
